import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'chooseLocationButtonLabel'
	| 'reparentFailedFlagTitle'
	| 'reparentFailedFlagDescription';

const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	chooseLocationButtonLabel: {
		id: 'malleable-ui-components.editor-remix.chooseLocationButtonLabel',
		defaultMessage: 'Choose a location',
		description:
			'Button label shown when the whiteboard could not be moved to the current page, prompting the user to select another location',
	},
	reparentFailedFlagTitle: {
		id: 'malleable-ui-components.editor-remix.reparentFailedFlagTitle',
		defaultMessage: 'Could not add diagram',
		description:
			"Title of the error flag shown when we couldn't automatically move the diagram to the current page's space (typically because the user lacks permission), prompting them to choose a different space",
	},
	reparentFailedFlagDescription: {
		id: 'malleable-ui-components.editor-remix.reparentFailedFlagDescription',
		defaultMessage:
			"You don't have permission to add content to this space. Choose a different space.",
		description:
			"Description of the error flag shown when we couldn't automatically move the diagram to the current page's space because the user lacks permission, telling them to pick a different space",
	},
});

export default messages;
